export const PAGE_DATA_LOADED = 'PAGE_DATA_LOADED';
